import fetch from "../interceptor/fetchInterceptor";

export function getAllDrivers() {
    return fetch({
        url: "/admin/drivers",
        method: "get",
        headers: {
            "public-request": "true",
        },
    });
}

export function getDriverRides() {
    return fetch({
        url: "/admin/driver/rides",
        method: "get",
        headers: {
            "public-request": "true",
        },
    });
}

export function verifyDriver(passData) {
    return fetch({
        url: "/admin/verify-driver",
        method: "post",
        headers: {
            "public-request": "true",
        },
        data: passData,
    });
}

export function connectDriver(passData) {
    return fetch({
        url: "/admin/connect-driver",
        method: "post",
        headers: {
            "public-request": "true",
        },
        data: passData,
    });
}

export function reVerifyDriver(passData) {
    return fetch({
        url: "/admin/re-verify-driver",
        method: "post",
        headers: {
            "public-request": "true",
        },
        data: passData,
    });
}

export function editDriverProfile(passData) {
    return fetch({
        url: "/admin/edit-profile/driver",
        method: "post",
        headers: {
            "public-request": "true",
        },
        data: passData,
    });
}
